module.exports = __webpack_public_path__ + "img/shield-beowulf.8e15eb0b.jpg";